module.exports = __webpack_public_path__ + "static/media/news-20160403-img01.076c6381.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/news-20160403-img01.png
// module id = 519
// module chunks = 0